import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  HubElementContentType,
  useLightningOutDataQuery,
} from '../../../__generated__/graphql';
import LightningOutWidget from '../LightningOutWidget';
import { FlairBreadcrumbContext } from '../../../../../context/FlairBreadcrumbContext';

const CustomLightningOutPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { componentUrl } = useParams<{ componentUrl: string }>();
  const { t } = useTranslation();
  const { setBreadcrumbItems } = useContext(FlairBreadcrumbContext);
  const { data, loading } = useLightningOutDataQuery({
    fetchPolicy: 'network-only',
  });

  const components = data?.hubElementDefinitions || [];
  const component = componentUrl
    ? components.find(
        (c) => (c.flair__Page_Url__c || `default-${c.Id}`) === componentUrl,
      )
    : null;

  const breadcrumbLabel =
    component?.flair__Menu_Item_Name__c ||
    t('dashboard.lightningOutWidget.customComponent');

  useEffect(() => {
    if (!loading) {
      setBreadcrumbItems([{ label: breadcrumbLabel ?? '' }]);
    }
    return () => setBreadcrumbItems([]);
  }, [breadcrumbLabel, loading, setBreadcrumbItems]);

  if (loading || !component) {
    return null;
  }

  const contentType = component.config.contentType;

  if (
    contentType === HubElementContentType.Lwc &&
    component.config.lwcComponentName
  ) {
    return (
      <LightningOutWidget
        key={componentUrl}
        lwcComponentName={component.config.lwcComponentName}
        sfInstanceUrl={data?.organizationInfo?.sfInstanceUrl ?? undefined}
        lightningAppId={data?.organizationInfo?.lightningAppId ?? undefined}
      />
    );
  }

  if (
    contentType === HubElementContentType.Flow &&
    component.flair__Flow_API_Name__c
  ) {
    return (
      <LightningOutWidget
        key={componentUrl}
        flowApiName={component.flair__Flow_API_Name__c}
        sfInstanceUrl={data?.organizationInfo?.sfInstanceUrl ?? undefined}
        lightningAppId={data?.organizationInfo?.lightningAppId ?? undefined}
      />
    );
  }

  return null;
};

export default CustomLightningOutPage;
